<template>
<div>
  <span v-for="item in fileList" :key="item.id" class="file-list" style="
        border: 1px solid #eeeeee;
        display: inline-block;
        width: 216px;
        height: 32px;
        line-height: 32px;
        position: relative;
        padding-left: 8px;
        margin-top: 10px;
      ">
    <eco-icon :name="getFileIcon(item)" style="font-size: 16px; float: left; margin-top: 8px"></eco-icon>
    <a @click.prevent="download(item)">
      <span class="file-container" :title="item.fileName">
        {{item.fileName}}
      </span>
      <a-icon type="download" title="下载" style="
            float: right;
            margin-right: 12px;
            font-size: 16px;
            margin-top: 8px;
          " />
    </a>
  </span>
</div>
</template>

<script>
import {env} from 'eco-cli'

export default {
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      config: env.config()
    };

  },
  methods: {
    // 文件图标准换
    getFileIcon(item) {
      let fileType = item.fileName.slice(item.fileName.lastIndexOf('.') + 1, item.fileName.length).toLowerCase();
      if (
        fileType === "png" ||
        fileType === "bmp" ||
        fileType === "jpeg" ||
        fileType === "jpg" ||
        fileType === "gif" ||
        fileType === "tiff"
      ) {
        fileType = "jpg";
      }
      if (
        fileType === "wav" ||
        fileType === "mp3" ||
        fileType === "au" ||
        fileType === "aiff" ||
        fileType === "ram"
      ) {
        fileType = "mp3";
      }
      if (
        fileType === "mp4" ||
        fileType === "mov" ||
        fileType === "rmvb" ||
        fileType === "rm" ||
        fileType === "flv" ||
        fileType === "3gp" ||
        fileType === "avi" ||
        fileType === "vob" ||
        fileType === "mpeg" ||
        fileType === "wmv" ||
        fileType === "mpe"
      ) {
        fileType = "mp4";
      }
      if (
        fileType === "zip" ||
        fileType === "rar" ||
        fileType === "7z" ||
        fileType === "tar" ||
        fileType === "cab"
      ) {
        fileType = "zip";
      }
      switch (fileType) {
        case "pdf":
          return "i-pdf";
        case "xls":
          return "i-excle";
        case "xlsx":
          return "i-excle";
        case "ppt":
          return "i-ppt";
        case "pptx":
          return "i-ppt";
        case "doc":
          return "i-word";
        case "docx":
          return "i-word";
        case "jpg":
          return "i-tupian";
        case "zip":
          return "rar-";
        case "exe":
          return "icon-exe";
        default:
          return "i-qita";
      }
    },
    download(record) {
      let href = this.config.file_origin + 'eco-file-server/file/eco/download/' + record.fileId
      window.open(href, "_self");
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.file-container {
  display: inline-block;
  font-size: 12px;
  line-height: 12px;
  padding-left: 6px;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-list {
  margin-right: 10px;

  a {
    color: #777777;

    &:hover {
      color: #4771F8;
    }
  }
}
</style>
